<template>
  <div class="confirm-layout">
    <div class="alert alert-success">
      <span>此藥盒最大存量: {{ currentDrugInDevice.max_stock }}</span>
      <span class="float-right">此藥物安全存量: {{ selectedDrugLowAmountLimitData.min_stock }}</span>
    </div>
    <RxCheckBarcode v-if="currentProgress === 'rxCheck'" v-on:confirmRx="confirmRx"/>
    <Action
    v-if="currentProgress === 'action'"
    :defaultNum="currentDrugInDevice.stock"
    :deviceId="currentDrugInDevice.device.id"
    :checkNum="currentDrugInDevice.max_stock"
    :valueMoreThanZero="false"
    :defaultPackCount="currentDrugInDevice.pack_count"
    :limitPackCount="false"
    v-on:setActionData="getActionData">
      <h5>此藥盒目前數量</h5>
    </Action>
    <Loader v-if="currentProgress === 'next'"/>
    <ResetLowAmonutModal v-if="modalStatus.lowAmount" v-on:closeModal="closeModal"/>
  </div>
</template>


<script>
import ConfirmFlowBase from '../ComponentBase/ConfirmFlowBase';
import Action from '../flowComp/Action';
import Loader from '../common/Loader';
import ResetLowAmonutModal from '../flowComp/ResetLowAmountLimit';
import RxCheckBarcode from '../flowComp/RxCheckBarcode';

export default {
  name: 'ConfirmFlow',
  extends: ConfirmFlowBase,
  data() {
    return {
      storageAmount: 0,
      packCount: 0,
      reviewer: undefined,
    };
  },
  components: {
    Action,
    Loader,
    ResetLowAmonutModal,
    RxCheckBarcode,
  },
  destroyed() {
    this.closeModal();
  },
  methods: {
    confirmRx(reviewer) {
      this.reviewer = reviewer.id;
      this.nextProgress();
    },
    closeModal() {
      this.$store.commit('SHOW_MODAL', { modalName: 'lowAmount', status: false });
    },
    async getActionData(data) {
      this.storageAmount = parseInt(data.num, 10);
      this.packCount = parseInt(data.packCount, 10);
      this.nextProgress();
      // close the modal before leaving
      this.closeModal();
      await this.emitData();
    },
    emitData() {
      let eventType;
      if (this.storageAmount === this.currentDrugInDevice.stock) {
        eventType = 'INVENTORY';
      } else {
        eventType = 'STORAGE_ERROR';
      }

      const data = {
        id: this.currentDrugInDevice.id,
        device: this.currentDrugInDevice.device.id,
        stock: this.storageAmount, // only update here.
        max_stock: this.currentDrugInDevice.max_stock,
        expired_date: this.currentDrugInDevice.expired_date,
        patch_number: this.currentDrugInDevice.patch_number,
        medication: this.currentDrugInDevice.medication.id,
        pack_count: this.packCount,
        number1: this.storageAmount - this.currentDrugInDevice.stock, // delta
        type: eventType,
        review_employee: this.reviewer,
      };

      return this.instance.put(`/api/drug-storage/${data.id}/`, data)
      .then((res) => {
        setTimeout(() => {
          this.$emit('confirmationFinish');
          this.resetProgress();
        });
      });
    },
  },
  mounted() {
  },
  computed: {
    selectedDrugLowAmountLimitData() {
      return this.$store.getters.selectedDrugLowAmountLimitData;
    },
    modalStatus() {
      return this.$store.getters.modalStatus;
    },
  },
};
</script>



// WEBPACK FOOTER //
// ConfirmFlow.vue?799003c4